
const Footer = () => {
    return(
        // <!-- Footer -->
        <footer className="sticky-footer bg-white">
            <div className="container my-auto">
                <div className="copyright text-center my-auto">
                    <span>Copyright &copy; Morgen Green Limited</span>
                </div>
            </div>
        </footer>
        // <!-- End of Footer -->
    )
}

export default Footer;